import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import TopNavBarSpan from "./TopNavBarSpan";
import { showGrade } from "../utils/textUtils";
import "./TopNavBar.css";

// 학원 로고: 주소가 있을 때만 이미지를 보여준다.
// 학생 화면에는 기본 로고를 두지 않는다. 학원이 로고를 안 걸었으면 그 자리를 비운다.
// (교사 화면은 반대로 ECHO 기본 로고를 띄운다. 우리 서비스 안이라는 표시가 필요해서다.)
const AcademyLogo = ({ src }) => {
  const [failed, setFailed] = useState(false);

  // 로고 주소가 바뀌면(재로그인 등) 실패 상태 초기화
  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) {
    return null;
  }

  return (
    <img
      src={src}
      alt="학원 로고"
      onError={() => setFailed(true)}
      className="student-nav__logo"
    />
  );
};

// 상단 바 한 줄에 [학원 로고] [메뉴] [학생 이름] 을 모두 둔다. teacher 상단 바와 같은 배치다.
const TopNavBar = ({ topTab, selectTab, tabList }) => {
  const { student } = useSelector((state) => state.student);

  let gradeText = "";
  try {
    if (student?.grade !== undefined && student?.grade !== null) {
      gradeText = showGrade(student.grade);
    }
  } catch (e) {
    gradeText = "";
  }

  return (
    <div className="student-nav">
      <div className="student-nav__inner">
        <div className="student-nav__side">
          <AcademyLogo src={student?.logo_img} />
        </div>

        <div className="student-nav__tabs">
          {tabList.map((tab) => (
            <TopNavBarSpan
              key={tab.name}
              topTab={topTab}
              selectTab={selectTab}
              tabName={tab.name}
              tabText={tab.text}
            />
          ))}
        </div>

        <div className="student-nav__side student-nav__side--right">
          <b className="student-nav__student-name">{student?.name || ""}</b>
          {gradeText && <span className="student-nav__student-grade">{gradeText}</span>}
        </div>
      </div>
    </div>
  );
};

export default TopNavBar;
